import $ from 'jquery';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Classes, Elements, Events } from '../global/constants';
import { ajax } from '../global/helpers';
import { animateSection } from '../animations/scroll';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Ajax Posts ----------

	if(typeof ajax_posts_params !== 'undefined') {

		$('form.ajax-posts-form').each(function() {

			const form = $(this);
			const button = form.find('button[type=submit]');
			const page = form.find('input[name=page]');
			const filters = form.find('.ajax-posts-filter');
			const content = form.find('.ajax-posts');
			const noResults = form.find('.no-results');

			button.on('click', () => form.data('append', true));

			filters.on('change', () => {
				form.data('append', false);
				page.val(1);
				form.submit();
			});

			form.on('submit', async e => {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				button.attr('disabled', true);
				Elements.LoadingBar.classList.add(Classes.loading);

				const form_data = new FormData(form[0]);
				form_data.append('action', ajax_posts_params.action);

				try {

					const response = await ajax({
						url: ajax_posts_params.admin_url,
						type: 'POST',
						dataType: 'json',
						data: form_data,
						processData: false,
						contentType: false,
					});

					if(response.data.content) {
						noResults.addClass(Classes.hidden);

						if(!form.data('append')) {
							content.empty();
						}
						const posts = $(response.data.content);

						content.append(posts);
						content.removeClass(Classes.hidden);
						posts.filter('.animated-section').each((index, section) => animateSection(section));
						ScrollTrigger.refresh();
					}
					else {
						content.addClass(Classes.hidden);
						noResults.removeClass(Classes.hidden);
					}

					if(response.data.next_page === 0) {
						button.addClass(Classes.hidden);
						button.attr('disabled', true);
					}
					else {
						page.val(response.data.next_page);
						button.removeClass(Classes.hidden);
					}
				}
				catch(e) {
					content.addClass(Classes.hidden);
					noResults.removeClass(Classes.hidden);
				}

				button.attr('disabled', false);
				Elements.LoadingBar.classList.remove(Classes.loading);

				return false;
			});
		});
	}
});
